
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import Loader from './Loader';

const RepoList = () => {
    const [repos, setRepos] = useState(null);
    const [error, setError] = useState('')
    const girRepos = async () => {
        try {
            const res = await fetch('https://api.github.com/search/repositories?q=xxx');
            const data = await res.json();
            setRepos(data.items);
            console.log(data.items);
            return data.items;
        } catch (err) {
            setError('Failed to fetch the data', err);
        }
    }
    useEffect(() => girRepos, []);

    return <div className='user-list'>
        {repos ?
            repos.map((repo) =>
                <div className='user-box' key={repo.id}>
                    <img src={repo.owner.avatar_url} alt='Avatar' />
                    <p>Name: <span className='repo-detail'>{repo.name}</span></p>
                    <p>Language: <span className='repo-lang'>{repo.language}</span></p>
                    <p>Repo: <span className='repo-detail'><Link to={`https://www.mrhussain.in/portfolio/github-explore/users/user/${repo.owner.login}`}>{repo.owner.login}</Link></span></p>
                    <Link to={`https://www.mrhussain.in/portfolio/github-explore/repo-detail/${repo.name}/${repo.owner.login}`} className='repo-btn'>View Repo</Link>
                </div>)
            :
            <div className='loader-box'>
                <Loader />
                <p>{error}</p>
            </div>
        }
    </div >
}

export default RepoList;